<script>
import { mapGetters } from 'vuex';
import { getUndefinedVariablesInMessage } from '@chatwoot/utils';
import { getExtendedMessageVariables } from 'shared/helpers/messageVariablesHelper';

import { MESSAGE_MAX_LENGTH } from 'shared/helpers/MessageTypeHelper';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

import MentionBox from '../mentions/MentionBox.vue';
import CannedResponseVariablesModal from '../modal/CannedResponseVariablesModal.vue';

export default {
  components: { MentionBox, CannedResponseVariablesModal },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: '',
    },
    inboxId: {
      type: Number,
      default: null,
    },
    senderId: {
      type: Number,
      default: null,
    },
  },
  emits: ['replace', 'cannedSelected'],
  data() {
    return {
      baseVariables: {},
      missingVariables: [],
      showVariblesModal: false,
      selectedCannedResponse: null,
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      cannedMessages: 'getCannedResponses',
    }),
    currentContact() {
      const contactId = this.currentChat?.meta?.sender?.id || this.senderId;
      if (!contactId) return null;
      return this.$store.getters['contacts/getContact'](contactId);
    },
    emptyConversation() {
      return {
        inbox_id: this.inboxId,
        meta: {
          sender: this.currentContact,
        },
      };
    },
    currentConversation() {
      return this.currentChat?.id ? this.currentChat : this.emptyConversation;
    },
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        id: cannedMessage.id,
      }));
    },
    maxLength() {
      if (this.channelType === INBOX_TYPES.FB) {
        return MESSAGE_MAX_LENGTH.FACEBOOK;
      }
      if (this.channelType === INBOX_TYPES.WHATSAPP) {
        return MESSAGE_MAX_LENGTH.TWILIO_WHATSAPP;
      }
      if (this.channelType === INBOX_TYPES.SMS) {
        return MESSAGE_MAX_LENGTH.TWILIO_SMS;
      }
      if (this.channelType === INBOX_TYPES.EMAIL) {
        return MESSAGE_MAX_LENGTH.EMAIL;
      }
      return MESSAGE_MAX_LENGTH.GENERAL;
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      const inboxId = this.currentConversation.inbox_id || this.inboxId;
      this.$store.dispatch('getCannedResponse', {
        searchKey: this.searchKey,
        inboxId,
      });
    },
    handleMentionClick(item = {}) {
      this.baseVariables = getExtendedMessageVariables({
        conversation: this.currentConversation || {},
        contact: this.currentContact || {},
      });
      this.selectedCannedResponse = item;
      this.missingVariables = getUndefinedVariablesInMessage({
        message: item.description,
        variables: this.baseVariables,
      });
      this.showVariblesModal = !!this.missingVariables.length;
      if (!this.showVariblesModal) this.onSubmit(item.description);
    },
    onSubmit(finalMessage) {
      this.$emit('replace', finalMessage);
      this.$emit('cannedSelected', this.selectedCannedResponse.id);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div>
    <MentionBox
      v-if="items.length"
      :items="items"
      @mention-select="handleMentionClick"
    />
    <CannedResponseVariablesModal
      :show="showVariblesModal"
      :max-length="maxLength"
      :variables="baseVariables"
      :missing-variables="missingVariables"
      :template="selectedCannedResponse?.description"
      @on-close="showVariblesModal = false"
      @on-submit="onSubmit"
    />
  </div>
</template>
